export default __webpack_public_path__ + "static/media/calender.936860dc.svg";